import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScreenOption } from '@app/preview/journey-pdf-preview/additional-screens-list';
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
  selector: 'app-screen-selection-dialog',
  templateUrl: './screen-selection-dialog.component.html',
  styleUrls: ['./screen-selection-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, CheckboxComponent],
})
export class ScreenSelectionDialogComponent implements OnInit, OnDestroy {
  @Input() title: string = 'Choose Additional Screens';
  @Input() screens: ScreenOption[];
  @Input() maxSelections?: number;
  @Input() minSelections?: number = 0;

  @Output() confirmed = new EventEmitter<ScreenOption[]>();

  showDialog = signal<boolean>(false);
  currentSelectionsState: ScreenOption[] = [];

  ngOnInit() {}

  ngOnDestroy() {
    this.allowBodyScroll();
  }

  showScreenSelection(): void {
    //Make a copy of the current selections to allow cancelling
    this.currentSelectionsState = [...this.screens];

    // Then open the dialog
    this.showDialog.set(true);
    this.preventBodyScroll();
  }

  onCheckboxChange(screen: ScreenOption, checked: boolean): void {
    // Update the screen selection state
    const screenIndex = this.currentSelectionsState.findIndex(
      (s) => s.id === screen.id,
    );
    const current = this.currentSelectionsState[screenIndex];
    this.currentSelectionsState[screenIndex] = {
      ...current,
      selected: checked,
      // Deselecting a screen that supports an error state also clears the
      // sub-option, so a hidden sub-checkbox can't leave a stale error page in
      // the export. Screens without error-state support keep it undefined.
      ...(!checked && current.includeErrorState !== undefined
        ? { includeErrorState: false }
        : {}),
    };
  }

  onErrorStateChange(screen: ScreenOption, checked: boolean): void {
    const screenIndex = this.currentSelectionsState.findIndex(
      (s) => s.id === screen.id,
    );
    this.currentSelectionsState[screenIndex] = {
      ...this.currentSelectionsState[screenIndex],
      includeErrorState: checked,
    };
  }

  confirmSelection(): void {
    this.confirmed.emit(this.currentSelectionsState);
    this.close();
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.currentSelectionsState = [];
    this.showDialog.set(false);
    this.allowBodyScroll();
  }

  private preventBodyScroll(): void {
    document.getElementsByTagName('body')[0].classList.add('body--fixed');
  }

  private allowBodyScroll(): void {
    document.getElementsByTagName('body')[0].classList.remove('body--fixed');
  }
}
